function getLocalStorage(): Storage | null {
  if (typeof window === "undefined") return null
  try {
    return window.localStorage
  } catch {
    return null
  }
}

export function readStorage(key: string): string | null {
  const storage = getLocalStorage()
  if (!storage) return null
  try {
    return storage.getItem(key)
  } catch {
    return null
  }
}

export function writeStorage(key: string, value: string): boolean {
  const storage = getLocalStorage()
  if (!storage) return false
  try {
    storage.setItem(key, value)
    return true
  } catch {
    return false
  }
}

export function removeStorage(key: string): void {
  const storage = getLocalStorage()
  if (!storage) return
  try {
    storage.removeItem(key)
  } catch {
    // Best-effort only.
  }
}

export function browserLocalStorage(): Storage | null {
  return getLocalStorage()
}
